<template>
    <div>
        <DialogoBlockTramite ref="dialBlock" type="familiares" width="500" />
        <v-hover v-slot="{ hover }">
            <v-card class="rounded-xl" outlined style="border: 1px solid #eeeeee;  cursor: pointer;"
                :elevation="hover ? 5 : 0" @click.stop="listarDatosFamiliares">
                <v-card-title class="d-flex primary--text font-weight-bold mx-3"
                    :class="($vuetify.breakpoint.mdAndDown) ? 'text-h6' : 'text-h5'" style="word-break: keep-all;">
                    Familiares
                    <v-avatar color="primary darken-1" size="29" class="ml-3 font-weight-bold white--text text-body-2">
                        {{ Object.keys(familiar).length }}
                    </v-avatar>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-if="$vuetify.breakpoint.mdAndUp" v-bind="attrs" v-on="on" fab
                                color="primary lighten-1" small class="elevation-0 ml-auto"
                                @click.stop="listarDatosFamiliares">
                                <v-icon>mdi-pencil-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Editar familiares</span>
                    </v-tooltip>
                </v-card-title>
                <div v-if="loadingFamiliar" class="px-10 py-2 d-flex flex-column">
                    <div class="py-2">
                        <v-skeleton-loader type="text" max-width="50%" class="mb-1" />
                        <v-skeleton-loader type="text" max-width="35%" class="mb-1" />
                        <v-skeleton-loader type="text" max-width="25%" />
                    </div>
                    <v-divider />
                    <div class="py-2">
                        <v-skeleton-loader type="text" max-width="50%" class="mb-1" />
                        <v-skeleton-loader type="text" max-width="35%" class="mb-1" />
                        <v-skeleton-loader type="text" max-width="25%" />
                    </div>
                </div>
                <v-list v-else-if="familiar.length" class="d-flex flex-column px-10">
                    <template v-for="(item, index) in familiarOrdenado">
                        <v-list-item class="pa-0">
                            <v-list-item-content class="py-2">
                                <v-list-item-title class="font-weight-bold black--text text--darken-1 text-body-1">
                                    {{ item.nombres }} {{ item.apellido }}
                                </v-list-item-title>
                                <v-list-item-subtitle
                                    v-if="item.destipfamiliar !== 'PADRE' && item.destipfamiliar !== 'MADRE'">{{
                                        item.destipdoc }} {{ item.nrodoc }}</v-list-item-subtitle>
                                <v-list-item-subtitle>{{ item.destipfamiliar }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider v-if="index < familiarOrdenado.length - 1" :key="'divider-' + index"></v-divider>
                    </template>
                </v-list>
                <div v-else
                    class="d-flex flex-row justify-center align-center font-weight-regular grey--text text--darken-5 pb-5">
                    No hay familiares registrados
                </div>
                <!-- <v-card-actions class="d-flex justify-end">
                    <v-tooltip bottom v-if="familiar.length > 2">
                        <template v-slot:activator="{ on, attrs }">
                            <v-chip v-bind="attrs" v-on="on" color="primary " @click="listarDatosFamiliares">
                                <v-icon left>
                                    mdi-eye-outline
                                </v-icon>
                                Ver más
                            </v-chip>
                        </template>
                        <span>Listado de familiares</span>
                    </v-tooltip>
                </v-card-actions> -->
            </v-card>
        </v-hover>
    </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'
import DialogoBlockTramite from '@/components/dialogos/DialogoBlockTramite.vue'
export default {
    name: "FamiliaresCard",
    data() {
        return {

        }
    },
    components: {
        DialogoBlockTramite
    },
    methods: {
        ...mapActions('dataUser', ['copiarFamiliares', 'deleteAllFam', 'guardarDatosPersonales', 'guardarDatosFamiliares', 'preparaFormPersonales', 'deleteAllArchFam']),

        listarDatosFamiliares() {
            if (this.familiar.length === 0) {
                this.$refs.dialBlock.abrirDialogo()
                return
            }
            this.$router.push('/listarFamiliares').catch(() => { })
        }

    },
    computed: {
        ...mapGetters(['familiar', 'loadingFamiliar']),
        filtroFam() {
            return this.familiar.slice(0, 2)
        },
        familiarOrdenado() {
            return this.familiar.slice().sort((a, b) => {
                if (a.destipfamiliar < b.destipfamiliar) return -1;
                if (a.destipfamiliar > b.destipfamiliar) return 1;
                return 0;
            }).slice(0, 2);
        }
    }
}
</script>